const items = (that) => [
    {
        get enabled() {
            return true; //that?.checkPermission("chatbot.stories.view");
        },
        key: "all-automations",
        group: "Automations",
        label: "All Automations",
        icon: {
            type: "material-icons",
            name: "settings_suggest",
        },
    },
    {
        get enabled() {
            return true; //that?.checkPermission("chatbot.stories.view");
        },
        key: "scheduled-automations",
        group: "Automations",
        label: "Scheduled Automations",
        icon: {
            type: "material-icons",
            name: "timer",
        },
    },
    {
        get enabled() {
            return true; //that?.checkPermission("chatbot.stories.view");
        },
        key: 'event-based-automations',
        group: "Automations",
        label: "Event Based Automations",
        icon: {
            type: "material-icons",
            name: "hearing",
        },
    },
    {
        get enabled() {
            return true; //that?.checkPermission("chatbot.stories.view");
        },
        key: "button-automations",
        group: "Automations",
        label: 'Button Automations',
        icon: {
            type: "material-icons",
            name: "ads_click",
        },
    },
    {
        get enabled() {
            return true; //that?.checkPermission("chatbot.stories.view");
        },
        key: "webhook-automations",
        group: "Automations",
        label: 'Webhook Automations',
        icon: {
            type: "material-icons",
            name: "webhook",
        },
    },
];

export default items;
